import { createContext, useCallback, useContext, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

const WipeCtx = createContext(null);

export function PageWipeProvider({ children }) {
    const [wipe, setWipe] = useState(false);
    const navigate = useNavigate();
    const busy = useRef(false);

    const wipeTo = useCallback(
        (path, afterHash) => {
            if (busy.current) return;
            busy.current = true;
            setWipe(true);
            setTimeout(() => {
                navigate(path);
                window.__lenis?.scrollTo(0, { immediate: true });
                window.scrollTo(0, 0);
            }, 580);
            setTimeout(() => {
                setWipe(false);
                busy.current = false;
                if (afterHash) {
                    setTimeout(() => {
                        const el = document.querySelector(afterHash);
                        if (el) window.__lenis ? window.__lenis.scrollTo(el) : el.scrollIntoView();
                    }, 350);
                }
            }, 1150);
        },
        [navigate]
    );

    return (
        <WipeCtx.Provider value={wipeTo}>
            {children}
            <AnimatePresence>
                {wipe && (
                    <motion.div
                        data-testid="page-wipe"
                        aria-hidden="true"
                        className="fixed inset-0 z-[80] flex items-center justify-center bg-[#D60024]"
                        style={{ transformOrigin: "bottom" }}
                        initial={{ scaleY: 0 }}
                        animate={{ scaleY: 1 }}
                        exit={{ y: "-100%", transition: { duration: 0.55, ease: [0.16, 1, 0.3, 1] } }}
                        transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
                    >
                        <span className="font-display text-6xl text-[#0A0A0A]">+</span>
                    </motion.div>
                )}
            </AnimatePresence>
        </WipeCtx.Provider>
    );
}

export const useWipe = () => useContext(WipeCtx);
